import { useState } from "react";
import emailjs from '@emailjs/browser';
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send');
  const [status, setStatus] = useState({});

  const onFormUpdate = (category, value) => {
      setFormDetails({
        ...formDetails,
        [category]: value
      })
  }

  // New email code
  // const form = useRef();
  const sendEmail = () => {
    console.log('inside sendEmail')
    console.log("formDetails: ", formDetails)
    const content = JSON.stringify(formDetails)
    console.log("content: ", content)

    emailjs
    .send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      formDetails,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
    .then(
      (result) => {
        console.log(result.text);
        setFormDetails(formInitialDetails);
        setStatus({
          success: true,
          message: "Message sent successfully",
        });
        setButtonText("Send");
      },
      (error) => {
        console.log(error.text);
        setStatus({
          success: false,
          message: "Something went wrong, please try again later.",
        });
        setButtonText("Send");
      }
    )
    .catch((error) => {
      console.log(error);
      setStatus({
        success: false,
        message: "Something went wrong, please try again later.",
      });
      setButtonText("Send");
    });
};
  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonText("Sending...");
    
      // check if atleast name and email fields are filled
      if (!formDetails.firstName.trim() && !formDetails.lastName.trim()) {
        setStatus({ success: false, message: "Please enter either your first name or last name." });
        setButtonText("Send");
        return;
      }
      console.log('validating!!')
      console.log(formDetails.email)
      console.log(formDetails.email.trim())
      if (!formDetails.email) {
        setStatus({
          success: false,
          message: "Please enter your email id.",
        });
        setButtonText("Send");
        return;
      }
    
      // Validate email format
      const emailRegex = /\S+@\S+\.\S+/;
      if (!emailRegex.test(formDetails.email)) {
        setStatus({
          success: false,
          message: "Please enter a valid email address.",
        });
        setButtonText("Send");
        return;
      }
      console.log('validated!!')
      console.log('sending email!!')
    // Send email via EmailJS
    sendEmail();
    // setButtonText("Send");

  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Get In Touch</h2>
                <form onSubmit={handleSubmit} method="POST">
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={formDetails.firstName} placeholder="First Name" onChange={(e) => onFormUpdate('firstName', e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={formDetails.lastName} placeholder="Last Name" onChange={(e) => onFormUpdate('lastName', e.target.value)}/>
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="tel" value={formDetails.phone} placeholder="Phone No." onChange={(e) => onFormUpdate('phone', e.target.value)}/>
                    </Col>
                    <Col size={12} className="px-1">
                      <textarea rows="6" value={formDetails.message} placeholder="Message" onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
                      <button type="submit"><span>{buttonText}</span></button>
                    </Col>
                  </Row>
                </form>
                {
                  status.message &&
                  <Row>
                  <h7 className={status.success === false ? "danger" : "success"} >{status.message}</h7>
                  </Row>
                }
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
